import React, { useEffect } from 'react';
import './App.css';
import Header from './Header'
import Home from './Home';
import {BrowserRouter as Router , Switch, Route } from "react-router-dom";
import Checkout from './Checkout';
import Login from './Login';
import {auth} from "./firebase"
import { useStateValue } from './StateProvider';
import Payment from './Payment';
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";
const promise = loadStripe('pk_test_51HR1WYKUlkyrhLaULg1hyrsJ6cYg6htbROGD2EVt6vIgYyIxQbsnDGdbm7z1esmQu0QoLCoZBfkoisjmTs7UtOVv00w8VTojsN');
function App() {
  const [{basket}, dispatch] = useStateValue();
 

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      console.log('THIS USER IS >>>', authUser);
      if(authUser){
          dispatch({
            type: 'SET_USER',
            user: authUser
          })
      }
      else{
        //user is logged out 
        dispatch({
          type: 'SET_USER',
          user: null
        })
      }
    })
    
  }, [])
  return (
    <Router>
    <div className="App" >

    <Switch>
    <Route path="/login">
      <Login/>
        </Route>

        <Route path="/checkout">
        <Header/>

        <Checkout/>
        </Route>
        <Route path="/payment">
        <Header/>
        <Elements stripe={promise}>
        <Payment/>

        </Elements>
        </Route>

        <Route path="/">
        <Header/>

            <Home/>
        </Route>
      </Switch>
    </div>
    </Router>
  );
}

export default App;
